import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AppProvider, Frame } from '@shopify/polaris';
import enTranslations from '@shopify/polaris/locales/en.json';

import AppNav from './components/AppNav';
import Dashboard from './pages/Dashboard';
import AttributesPage from './pages/AttributesPage';
import AttributeForm from './pages/AttributeForm';
import GroupsPage from './pages/GroupsPage';
import ProductsPage from './pages/ProductsPage';
import OrdersPage from './pages/OrdersPage';
import QuotesPage from './pages/QuotesPage';
import SalespersonRoutingPage from './pages/SalespersonRoutingPage';
import EmailTemplatesPage from './pages/EmailTemplatesPage';
import ConfigurationPage from './pages/ConfigurationPage';

export default function App() {
  return (
    <AppProvider 
      i18n={enTranslations}
      linkComponent={({ url, children, ...rest }) => (
        <a href={url} {...rest}>{children}</a>
      )}
    >
      <BrowserRouter basename="/admin">
        {/* Custom styled navigation bar — always visible at top of app */}
        <AppNav />

        {/* Frame is required by Polaris Toast/Modal components */}
        <Frame>
          <div style={{ minHeight: 'calc(100vh - 48px)' }}>
            <Routes>
              <Route path="/" element={<Dashboard />} />
              <Route path="/attributes" element={<AttributesPage />} />
              <Route path="/attributes/new" element={<AttributeForm />} />
              <Route path="/attributes/:id/edit" element={<AttributeForm />} />
              <Route path="/groups" element={<GroupsPage />} />
              <Route path="/products" element={<ProductsPage />} />
              <Route path="/orders" element={<OrdersPage />} />
              <Route path="/quotes" element={<QuotesPage />} />
              <Route path="/salespersons" element={<Navigate to="/salesperson-routing" replace />} />
              <Route path="/salesperson-routing" element={<SalespersonRoutingPage />} />
              <Route path="/email-templates" element={<EmailTemplatesPage />} />
              <Route path="/configuration" element={<ConfigurationPage />} />
            </Routes>
          </div>
        </Frame>
      </BrowserRouter>
    </AppProvider>
  );
}
